import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(public _router: Router) {
        
    }

    canActivate() {
        var usuario_logado = localStorage.getItem('usuarioLogado');
        if (usuario_logado != 'true') {
            this._router.navigate(['/login']);
        }
        return true;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/auth.guard.ts